// @flow
import { getCurrencyConversions, getCurrentCurrency } from '../../redux/modules/currency';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import type { ExtractReturn } from '../../types/redux';
import FormattedCurrency from './FormattedCurrency';
import { getLocale } from '../../redux/modules/intl';

type OwnProps = $ReadOnly<{|
    children?: any,
    convert?: boolean,
    fractionDigits?: number,
    noFraction?: boolean,
    sourceCurrency: string,
    value: number,
|}>;

const mapStateToProps = state => {
    const conversions = getCurrencyConversions(state) || [];
    const locale = getLocale(state);
    const targetCurrency = getCurrentCurrency(state);

    return {
        conversions,
        locale,
        targetCurrency,
    };
};

type ReduxProps = $ReadOnly<{|
    ...ExtractReturn<typeof mapStateToProps>,
    conversions: any[],
    locale: string,
    targetCurrency: string,
|}>;

type Props = $ReadOnly<{|
    ...OwnProps,
    ...ReduxProps,
|}>;

class FormattedCurrencyContainer extends Component<Props> {
    static defaultProps = {
        convert: true,
        noFraction: false,
    };

    render() {
        const {
            children,
            conversions,
            convert,
            fractionDigits,
            locale,
            noFraction,
            sourceCurrency,
            targetCurrency,
            value,
        } = this.props;

        return (
            <FormattedCurrency
                conversions={conversions}
                convert={convert}
                fractionDigits={fractionDigits}
                locale={locale}
                noFraction={noFraction}
                sourceCurrency={sourceCurrency}
                targetCurrency={targetCurrency}
                value={value}
            >
                {children}
            </FormattedCurrency>
        );
    }
}

export default connect(
    mapStateToProps
    // mapDispatchToProps
)(FormattedCurrencyContainer);
